/**
 * isPreprint tests if a paper is a preprint
 * by it's publication type or DOI.
 */
export default function isPreprint (type, doi) {
  if (type === 'posted-content') {
    return true
  }
  if (doi?.includes('10.48550/arxiv')) {
    return true
  }
  return false
}
